import { renderNothing, branch } from 'recompose'
import { withTranslatedMeta } from 'i18n/utils'
import { loadOnMount } from 'shared/hoc'
import { loadGoogleAPI } from 'map/actions'
import { googleAPIReadySelector } from 'map/selectors'
import MapViewComponent from 'map/components/mapView/MapView'

const MapView = () => <MapViewComponent />

export default compose(
    withTranslatedMeta('input.placeholder.search.park'),
    connect(
        createStructuredSelector({
            apiReady: googleAPIReadySelector,
        }),
        { loadGoogleAPI }
    ),
    loadOnMount(
        'loadGoogleAPI',
        () => [],
        props => !props.apiReady
    ),
    branch(props => !props.apiReady, renderNothing)
)(MapView)
